// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getAverage(collection: number[]) {
  if (collection.length) {
    const sum = collection.reduce((item, total) => total + item);
    return Math.round(sum / collection.length);
  }

  return 0;
}
